interface LineChartIconProps {
	size?: number | string;
	color?: string;
}

export function LineChartIcon({ size = 16, color }: LineChartIconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.06552 11.2435L7.6437 7.1271L10.5892 9.29437L13.8182 6.058M13.8182 13.818H3.47643C3.1331 13.818 2.80382 13.6816 2.56105 13.4388C2.31827 13.1961 2.18188 12.8668 2.18188 12.5235V2.18164"
				stroke={color || 'currentColor'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
